export const SYMBOLS_SET_SYMBOLS = "symbols/set-symbols";
